import React from "react";

export default function Rules() {
  return (
    <div>
      <h1>Rules</h1>
      <p>Your rules will appear here.</p>
    </div>
  );
}



